import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { authAPI } from '../../services/api';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      await authAPI.verifyEmail(token);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Verification failed. The link may be invalid or expired.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center">
        <LoadingSpinner size="lg" text="Verifying your email..." />
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4">
        <div className="w-full max-w-md space-y-8 text-center">
          <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto" />
          <h2 className="text-3xl font-bold text-slate-900 dark:text-white">Email Verified</h2>
          <p className="text-slate-600 dark:text-slate-400">
            Your email has been verified successfully. You now have full access to all CyberActions features.
          </p>
          <Link
            to="/dashboard"
            className="inline-block px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700"
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md space-y-8 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mx-auto" />
        <h2 className="text-3xl font-bold text-slate-900 dark:text-white">Verification Failed</h2>
        <p className="text-slate-600 dark:text-slate-400">{error}</p>
        <Link
          to="/login"
          className="inline-block text-primary-600 hover:text-primary-500 font-medium"
        >
          Back to login
        </Link>
      </div>
    </div>
  );
}
